import { Box, Container, Heading, Text, Button } from "@chakra-ui/react";
import { useLocation } from "wouter";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <Box minH="100vh" bg="bg.canvas">
      <Container centerContent py={20}>
        <Box textAlign="center">
          <Heading
            fontFamily="heading"
            fontWeight="800"
            fontSize="2xl"
            color="text.primary"
            mb={4}
          >
            404 — Page Not Found
          </Heading>
          <Text
            fontFamily="body"
            fontWeight="300"
            fontSize="sm"
            color="text.muted"
            mb={6}
          >
            The page you're looking for doesn't exist.
          </Text>
          <Button
            bg="accent.emphasis"
            color="white"
            _hover={{ bg: "accent.emphasisHover" }}
            fontFamily="body"
            fontWeight="500"
            onClick={() => setLocation("/")}
          >
            Go Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
}